import React, { Component } from 'react';
import SVG from 'react-inlinesvg';
import CalculateIcon from 'images/calculator-icon.svg';
import { joinClasses } from 'components/utils/react_helper';
import HttpRequestor from '~/components/http_requestor';
import I18n from '~/utils/translations';

export const ChargeTypes = {
  securityDepositAmount: 'security_deposit_amount',
  holdingDepositAmount: 'holding_deposit_amount',
  upfrontRentAmount: 'upfront_rent_amount',
};

export default class CalculateChargeButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      calculating: false,
      success: false,
      error: false,
    };
  }

  get calculatedChargesUrl() {
    return '/agents/charges';
  }

  get title() {
    if (this.state.error) {
      return I18n.t('pages.agents_form.calculator_button.error_title');
    }

    return I18n.t('pages.agents_form.calculator_button.title');
  }

  get classes() {
    const { calculating, error } = this.state;

    return joinClasses([
      'calculate-charge-button',
      this.disabled && 'calculate-charge-button--loading',
      error && 'calculate-charge-button--error',
    ]);
  }

  get disabled() {
    return !this.props.rentAmount || !this.props.moveInDate || this.state.calculating;
  }

  fetchCalculatedCharge = async () => {
    this.setState({ calculating: true }, async () => {
      const requestor = new HttpRequestor();

      const params = {
        property_id: this.props.propertyId,
        rent_amount: this.props.rentAmount,
        move_in_date: this.props.moveInDate,
      };

      try {
        const resp = await requestor.call(this.calculatedChargesUrl, 'POST', params);
        this.setState({ success: true, error: false });
        this.props.onCalculated(
          { [this.props.inputName]: Number(resp[this.props.calculatedValue]).toFixed(2) / 100 },
          this.props.inputRef
        );
      } catch (err) {
        this.setState({ success: false, error: true });
      } finally {
        this.setState({ calculating: false });
      }
    });
  };

  render() {
    return (
      <button title={this.title} className={this.classes} disabled={this.disabled} onClick={this.fetchCalculatedCharge}>
        <SVG className="calculate-charge-button__icon" src={CalculateIcon} />
      </button>
    );
  }
}
